<div class="linear-loading-indicator" *ngIf="loading">
    <div class="linear-loading-bar">
        <div class="linear-loading-progress"></div>
    </div>
</div>
